var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurface1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 122.008,
    height: 143.273,
    viewBox: "0 0 122.008 143.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "surface1",
    transform: "translate(-0.5 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25223",
    "data-name": "Path 25223",
    d: "M116.063,95.677a72.283,72.283,0,0,1-17.312,26.97c-8.693,8.489-20.077,15.234-33.834,20.046a10.349,10.349,0,0,1-3.288.58h-.124a10.5,10.5,0,0,1-2.018-.2A10.9,10.9,0,0,1,58.1,142.7c-13.774-4.8-25.172-11.546-33.874-20.035A72.147,72.147,0,0,1,6.918,95.7C-.075,76.721.323,55.816.643,39.018l.005-.258c.064-1.387.106-2.844.129-4.453a15.185,15.185,0,0,1,14.3-14.876c16.473-.919,29.216-6.292,40.1-16.9l.1-.087a9.178,9.178,0,0,1,12.46,0l.093.087c10.89,10.613,23.634,15.985,40.106,16.9a15.185,15.185,0,0,1,14.3,14.876c.023,1.62.064,3.075.129,4.453l0,.109C122.685,55.7,123.081,76.645,116.063,95.677Zm0,0",
    transform: "translate(0 0)",
    fill: "#672f6c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25224",
    "data-name": "Path 25224",
    d: "M273.384,95.679a72.283,72.283,0,0,1-17.312,26.97c-8.693,8.489-20.077,15.234-33.834,20.046a10.349,10.349,0,0,1-3.288.58V0a9.192,9.192,0,0,1,6.107,2.438l.093.087c10.89,10.613,23.634,15.985,40.106,16.9a15.185,15.185,0,0,1,14.3,14.876c.023,1.62.064,3.075.129,4.453l0,.109C280.006,55.7,280.4,76.648,273.384,95.679Zm0,0",
    transform: "translate(-157.321 -0.003)",
    fill: "#5f1f64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25225",
    "data-name": "Path 25225",
    d: "M162.309,164.105a35.751,35.751,0,0,1-35.581,35.708H126.6a35.707,35.707,0,1,1,0-71.414h.126A35.751,35.751,0,0,1,162.309,164.105Zm0,0",
    transform: "translate(-65.099 -92.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25226",
    "data-name": "Path 25226",
    d: "M254.53,164.105a35.751,35.751,0,0,1-35.581,35.708V128.4A35.751,35.751,0,0,1,254.53,164.105Zm0,0",
    transform: "translate(-157.321 -92.469)",
    fill: "#e1ebf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25227",
    "data-name": "Path 25227",
    d: "M188.384,219.156,172.3,235.24l-3.475,3.475a4.208,4.208,0,0,1-5.947,0l-7.471-7.475a4.2,4.2,0,1,1,5.944-5.944l4.5,4.5,16.585-16.585a4.2,4.2,0,1,1,5.944,5.944Zm0,0",
    transform: "translate(-110.674 -152.661)",
    fill: "#b4d2d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25228",
    "data-name": "Path 25228",
    d: "M235.031,219.156,218.949,235.24V223.348l10.137-10.136a4.2,4.2,0,0,1,5.944,5.944Zm0,0",
    transform: "translate(-157.321 -152.661)",
    fill: "#6fa5aa"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurface1);
export default __webpack_public_path__ + "static/media/surface1.4c6c6d7391519c848e1c350ae40ddd76.svg";
export { ForwardRef as ReactComponent };